<div class="content-container">
    <div class="p-3 pb-0">
        <div>
            Toast take 10 to hide, click on the toast to hide it if need be.
        </div>
        <hr>
    </div>
    <div class="content d-flex flex-wrap">
        <button class="mwp-button me-3 mb-3" (click)="infoToast()">
            Info
        </button>
        <button class="mwp-button-red me-3 mb-3" (click)="errorToast()">
            Error
        </button>
        <button class="mwp-button-orange me-3 mb-3" (click)="warningToast()">
            Warning
        </button>
        <button class="mwp-button-green me-3 mb-3" (click)="successToast()">
            Success
        </button>
    </div>
</div>